import { render, staticRenderFns } from "./HighlightedArticle.vue?vue&type=template&id=c712e43e&"
import script from "./HighlightedArticle.vue?vue&type=script&lang=js&"
export * from "./HighlightedArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c712e43e')) {
      api.createRecord('c712e43e', component.options)
    } else {
      api.reload('c712e43e', component.options)
    }
    module.hot.accept("./HighlightedArticle.vue?vue&type=template&id=c712e43e&", function () {
      api.rerender('c712e43e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/Highlighted/HighlightedArticle.vue"
export default component.exports